module.exports = __webpack_public_path__ + "static/media/bg3.e5ac82a2.jpg";